import { useEffect, useRef } from 'react';
var Step3Video = function Step3Video() {
  var videoRef = useRef(null);
  useEffect(function () {
    var options = {
      rootMargin: '-200px 0px -100px 0px',
      threshold: 1.0
    };
    var handlePlay = function handlePlay(entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          console.log('VIDEO 3 PLAY');
          videoRef.current.play();
          videoRef.current.defaultMuted = true;
          videoRef.current.muted = true;
          $('#video3').css({
            opacity: 1
          });
        } else {
          console.log('VIDEO 3 STOP');
          videoRef.current.pause();
          $('#video3').css({
            opacity: 0
          });
        }
      });
    };
    var observer = new IntersectionObserver(handlePlay, options);
    observer.observe(videoRef.current);
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "ht-step-3__video"
  }, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/hydro-tip/step3/video-3@2x.png",
    className: "ht-step-3__video-img"
  }), /*#__PURE__*/React.createElement("video", {
    id: "video3",
    ref: videoRef,
    muted: true
    // controls
    ,
    playsInline: true,
    src: "/public/videos/step-3.mp4"
    // src='https://archive.org/download/BigBuckBunny_124/Content/big_buck_bunny_720p_surround.mp4'
  }));
};
export default Step3Video;